export const AB_CONTENT = {
  hero: {
    kicker: 'Para quem vende a prazo e cansou de cobrar cliente na mão',
    title: 'Cobrar cliente por telefone e WhatsApp não é trabalho de dono de empresa.',
    subtitle:
      'Gere boleto e PIX automaticamente a partir da parcela da venda, com baixa automática no financeiro assim que o cliente paga. Sem planilha, sem ligação, sem esquecer vencimento.',
    cta: 'Quero parar de cobrar na mão',
    ctaMessage: 'Quero conhecer o sistema de cobrança automática do 77Gestão',
    urgency: 'Cada cobrança feita na mão é tempo que devia estar na operação, não atrás de pagamento.',
  },

  statsStrip: [
    { number: 'Automática', label: 'emissão de boleto e PIX', icon: 'fa-solid fa-barcode' },
    { number: 'Em tempo real', label: 'baixa quando o cliente paga', icon: 'fa-solid fa-check-double' },
    { number: '1 painel', label: 'para ver quem pagou e quem não pagou', icon: 'fa-solid fa-table-columns' },
  ],

  pain: {
    title: 'Reconhece alguma dessas situações? Então a cobrança está consumindo tempo que devia ser da operação.',
    intro:
      'Empresas que vendem a prazo ou parcelado perdem dinheiro e tempo todos os meses porque a cobrança ainda é feita manualmente. Não é falta de organização — é falta de automação.',
    items: [
      { icon: 'fa-solid fa-phone', text: 'Ligar ou mandar mensagem no WhatsApp cobrando cada cliente atrasado, um por um.' },
      { icon: 'fa-regular fa-calendar-xmark', text: 'Esquecer de gerar o boleto na data certa e atrasar o próprio recebimento.' },
      { icon: 'fa-solid fa-magnifying-glass-dollar', text: 'Não saber quem já pagou sem entrar no aplicativo do banco e conferir um por um.' },
      { icon: 'fa-solid fa-table-list', text: 'Anotar em planilha manualmente quem pagou, quem está atrasado e quem precisa de cobrança.' },
      { icon: 'fa-solid fa-snowplow', text: 'Perceber a inadimplência só quando ela já virou bola de neve no caixa.' },
    ],
  },

  midCta: {
    text: 'E se o boleto saísse sozinho na parcela certa e o financeiro se atualizasse na hora do pagamento?',
    cta: 'Quero ver na prática',
    ctaMessage: 'Quero ver uma demonstração do sistema de cobrança automática do 77Gestão',
  },

  solution: {
    title: 'Cobrança automática de ponta a ponta. Da venda ao dinheiro na conta.',
    intro:
      'O sistema de cobrança automática do 77Gestão usa a integração com o Asaas para transformar cada parcela de venda em uma cobrança que se resolve sozinha.',
    cards: [
      {
        icon: 'fa-solid fa-barcode',
        title: 'Boleto e PIX gerados automaticamente',
        text: 'Cada parcela da venda vira uma cobrança via Asaas, sem você precisar gerar nada manualmente.',
      },
      {
        icon: 'fa-solid fa-check-double',
        title: 'Baixa automática quando o cliente paga',
        text: 'Assim que o pagamento é confirmado, o webhook do Asaas atualiza o financeiro sozinho — sem conferência manual de extrato.',
      },
      {
        icon: 'fa-solid fa-table-columns',
        title: 'Faturamento em massa com painel kanban',
        text: 'Gere e acompanhe cobranças em lote, com status visual de cada uma: pendente, pago, vencido.',
      },
      {
        icon: 'fa-solid fa-triangle-exclamation',
        title: 'Alerta de inadimplência',
        text: 'Saiba quem está atrasado antes que a situação se acumule, sem precisar caçar a informação.',
      },
      {
        icon: 'fa-solid fa-link',
        title: 'Conciliação automática com o financeiro',
        text: 'A cobrança nasce da parcela de venda e se resolve dentro do mesmo sistema, sem retrabalho de digitação.',
      },
    ],
  },

  proof: {
    title: 'O que muda quando a cobrança para de depender de quem lembra',
    intro:
      'Uma empresa que vendia parcelado cobrava cliente atrasado por telefone e conferia pagamento manualmente no banco, todos os dias, no fim da tarde.',
    stats: [
      { number: 'Automática', label: 'geração de boleto e PIX por parcela' },
      { number: '↓', label: 'tempo gasto conferindo pagamento no banco' },
      { number: 'Antecipado', label: 'alerta de cliente inadimplente' },
    ],
    paragraphs: [
      'Depois da implantação, toda parcela de venda passou a gerar automaticamente o boleto ou PIX pelo Asaas, sem intervenção manual da equipe.',
      'Quando o cliente pagava, o financeiro era baixado sozinho via webhook. A equipe deixou de perder tempo checando banco e passou a agir só sobre quem realmente estava inadimplente.',
    ],
    highlight: 'Resultado: cobrança em dia, menos tempo gasto no banco e inadimplência identificada antes de virar problema.',
    cta: 'Quero esse nível de automação',
    ctaMessage: 'Vi o resultado e quero entender como automatizar a cobrança no 77Gestão',
  },

  benefits: {
    title: 'Os três pilares de uma cobrança que funciona sozinha',
    items: [
      {
        icon: 'fa-solid fa-gears',
        title: 'Automação',
        text: 'Boleto e PIX gerados e baixados sem intervenção manual, direto a partir da venda.',
      },
      {
        icon: 'fa-solid fa-binoculars',
        title: 'Previsibilidade',
        text: 'Saiba com antecedência o que vai entrar no caixa e quem está atrasado no pagamento.',
      },
      {
        icon: 'fa-solid fa-shield-heart',
        title: 'Menos inadimplência',
        text: 'Alerta de atraso identificado cedo, para agir antes que o cliente acumule dívida.',
      },
    ],
  },

  differentials: {
    title: 'Por que empresas escolhem o 77Gestão para automatizar a cobrança',
    items: [
      { icon: 'fa-solid fa-plug', text: 'Integração real com Asaas: boleto e PIX nascem direto da parcela de venda.' },
      { icon: 'fa-solid fa-check-double', text: 'Baixa automática via webhook — o financeiro nunca fica desatualizado esperando conferência manual.' },
      { icon: 'fa-solid fa-table-columns', text: 'Faturamento em massa com painel kanban para acompanhar centenas de cobranças de uma vez.' },
      { icon: 'fa-solid fa-layer-group', text: 'Tudo dentro do mesmo ERP: venda, cobrança e financeiro conectados, sem sistema paralelo.' },
      { icon: 'fa-solid fa-headset', text: 'Suporte humano de verdade na implantação da integração de cobrança.' },
    ],
  },

  faq: {
    title: 'Dúvidas antes de automatizar sua cobrança',
    items: [
      {
        question: 'Preciso ter conta no Asaas para usar a cobrança automática?',
        answer:
          'Sim, a cobrança automática do 77Gestão funciona através da integração com o Asaas, que emite o boleto e o PIX em nome da sua empresa. A conta é configurada uma vez na implantação.',
      },
      {
        question: 'Como o sistema sabe que o cliente pagou?',
        answer:
          'O Asaas envia um webhook para o 77Gestão assim que o pagamento é confirmado, e o sistema dá baixa automaticamente na parcela correspondente, sem precisar conferir extrato manualmente.',
      },
      {
        question: 'Funciona só para boleto ou também para PIX?',
        answer:
          'Funciona para os dois. A cobrança pode ser gerada como boleto, PIX, ou ambos, conforme a configuração da venda.',
      },
      {
        question: 'Dá para cobrar muitos clientes de uma vez?',
        answer:
          'Sim, o faturamento em massa (billing) permite gerar cobranças em lote e acompanhar o status de cada uma em um painel kanban, sem precisar abrir cliente por cliente.',
      },
      {
        question: 'Isso substitui meu sistema de gestão financeira atual?',
        answer:
          'A cobrança automática já é parte do módulo financeiro do 77Gestão: a parcela nasce na venda, a cobrança é gerada pelo Asaas e a baixa acontece dentro do próprio financeiro, sem sistema paralelo.',
      },
    ],
  },

  ctaFinal: {
    title: 'Cobrar cliente não devia ser um trabalho manual todo mês.',
    subtitle:
      'Agende uma demonstração gratuita e veja como automatizar a emissão de boleto e PIX, com baixa automática assim que o cliente paga.',
    cta: 'Agendar demonstração agora',
    ctaMessage: 'Quero agendar uma demonstração do sistema de cobrança automática do 77Gestão',
  },

  seo: {
    title: 'Sistema de Cobrança Automática: Boleto e PIX | 77Gestão',
    description:
      'Sistema de cobrança automática com emissão de boleto e PIX via Asaas a partir da parcela de venda, baixa automática no financeiro e alerta de inadimplência.',
  },
};
